import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { CheckCircle2, Beaker, Package, Droplets, Layers } from "lucide-react";

const ProductDialog = ({ product, onClose, onQuote }) => {
  if (!product) return null;
  return (
    <Dialog open={!!product} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-[760px] max-h-[92vh] overflow-y-auto p-0">
        <div className="relative h-56 overflow-hidden rounded-t-lg">
          <img
            src={product.image}
            alt={`${product.name} (${product.formula}) — Industrial-grade ${product.name} Manufacturer & Supplier in India (Vapi, Gujarat)`}
            title={`${product.name} (${product.formula})`}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 to-transparent" />
          <div className="absolute bottom-4 left-5 right-5 text-white">
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-teal-200">Product details</div>
            <DialogTitle className="font-display text-[28px] font-extrabold text-white mt-1">{product.name} <span className="text-teal-200">({product.formula})</span></DialogTitle>
          </div>
        </div>
        <div className="p-6">
          <p className="text-slate-600 text-[15px] leading-relaxed">{product.short}</p>

          <div className="mt-6 grid sm:grid-cols-2 gap-3">
            <Spec icon={Beaker} label="Concentration" value={product.concentration} />
            <Spec icon={Droplets} label="Appearance" value={product.appearance} />
            <Spec icon={Layers} label="Grades" value={product.grades.join(", ")} />
            <Spec icon={Package} label="Packaging" value={product.packaging} />
          </div>

          <div className="mt-6">
            <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700 mb-3">Key applications</div>
            <ul className="grid sm:grid-cols-2 gap-2">
              {product.applications.map((a) => (
                <li key={a} className="flex items-start gap-2 text-[14px] text-slate-700">
                  <CheckCircle2 className="h-4.5 w-4.5 text-teal-700 mt-0.5 shrink-0" />
                  {a}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-7 flex flex-wrap gap-3">
            <Button onClick={() => { onQuote(product.name); onClose(); }} className="bg-teal-700 hover:bg-teal-800 text-white h-11 px-5 font-semibold">Get a quote for this product</Button>
            <Button variant="outline" onClick={onClose} className="h-11 px-5">Close</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const Spec = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3 p-3.5 rounded-xl bg-slate-50 border border-slate-200">
    <div className="h-9 w-9 rounded-lg bg-white border border-slate-200 flex items-center justify-center shrink-0">
      <Icon className="h-4.5 w-4.5 text-teal-700" />
    </div>
    <div>
      <div className="text-[11.5px] uppercase tracking-wider font-semibold text-slate-500">{label}</div>
      <div className="text-[14px] text-slate-800 font-medium mt-0.5">{value}</div>
    </div>
  </div>
);

export default ProductDialog;
